<template>
<NavBar></NavBar>
  <div class="container">
    <div class="row">
    <div class="col-md-10">
      <h1 class="text-center">Feature Requests</h1>
      <div v-if="loading">Loading...</div>

      <button @click="openForm" class="btn btn-success rounded-2 m-2">Add a new feature</button>

      <div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col" class="tableHeader" tabindex="0">
                <span class="featuretable" @click="sort('name')">
                  <span class="arrowStyle" v-if="sortBy==='name' && sortOrder===false">
                    <span><i class="fas fa-chevron-down"></i></span>
                  </span>
                  <span class="arrowStyle" v-else-if="sortBy==='name' && sortOrder===true">
                    <span><i class="fas fa-chevron-up"></i></span>
                  </span>
                  Feature
                </span>
              </th>
              <th scope="col" class="tableHeader" tabindex="0">
                <span class="featuretable" @click="sort('priority')">
                  <span class="arrowStyle" v-if="sortBy==='priority' && sortOrder===false">
                    <span><i class="fas fa-chevron-down"></i></span>
                  </span>
                  <span class="arrowStyle" v-else-if="sortBy==='priority' && sortOrder===true">
                    <span><i class="fas fa-chevron-up"></i></span>
                  </span>
                  Priority
                </span>
              </th>
              <th scope="col" class="tableHeader" tabindex="0">
                <span class="featuretable" @click="sort('section')">
                  <span class="arrowStyle" v-if="sortBy==='section' && sortOrder===false">
                    <span><i class="fas fa-chevron-down"></i></span>
                  </span>
                  <span class="arrowStyle" v-else-if="sortBy==='section' && sortOrder===true">
                    <span><i class="fas fa-chevron-up"></i></span>
                  </span>
                  Section
                </span>
              </th>
              <th scope="col" class="tableHeader" tabindex="0">
                <span class="featuretable" @click="sort('status')">
                  <span class="arrowStyle" v-if="sortBy==='status' && sortOrder===false">
                    <span><i class="fas fa-chevron-down"></i></span>
                  </span>
                  <span class="arrowStyle" v-else-if="sortBy==='status' && sortOrder===true">
                    <span><i class="fas fa-chevron-up"></i></span>
                  </span>
                  Status
                </span>
              </th>
              <th scope="col" class="tableHeader" tabindex="0">
                <span class="featuretable" @click="sort('version')">
                  <span class="arrowStyle" v-if="sortBy==='version' && sortOrder===false">
                    <span><i class="fas fa-chevron-down"></i></span>
                  </span>
                  <span class="arrowStyle" v-else-if="sortBy==='version' && sortOrder===true">
                    <span><i class="fas fa-chevron-up"></i></span>
                  </span>
                  Version
                </span>
              </th>
              <th scope="col" class="tableHeader" tabindex="0">
                <span class="featuretable" @click="sort('size')">
                  <span class="arrowStyle" v-if="sortBy==='size' && sortOrder===false">
                    <span><i class="fas fa-chevron-down"></i></span>
                  </span>
                  <span class="arrowStyle" v-else-if="sortBy==='size' && sortOrder===true">
                    <span><i class="fas fa-chevron-up"></i></span>
                  </span>
                  Size
                </span>
              </th>
              <th scope="col" class="tableHeader" tabindex="0">
                <span class="featuretable" @click="sort('likes')">
                  <span class="arrowStyle" v-if="sortBy==='likes' && sortOrder===false">
                    <span><i class="fas fa-chevron-down"></i></span>
                  </span>
                  <span class="arrowStyle" v-else-if="sortBy==='likes' && sortOrder===true">
                    <span><i class="fas fa-chevron-up"></i></span>
                  </span>
                  Likes
                </span>
              </th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(feature, featureId) in features" :key="featureId">
              <td>{{ feature.name }}</td>
              <td>{{ priorities[feature.priority] }}</td>
              <td>{{ feature.section }}</td>
              <td>{{ feature.status }}</td>
              <td>{{ feature.version }}</td>
              <td>{{ feature.size }}</td>
              <td>{{ feature.likes }}</td>
              <td>
                <div>
                  <span @click="getLikeFeature(feature.id)">
                    <span class="fa fa-thumbs-up m-1"/>
                  </span>
                  <span @click="fillForm(feature.id)">
                    <span class="fa fa-pen m-1"/>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="showModal" class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">

            <div class="modal-header">
              <slot name="header">{{ action }} Feature</slot>
            </div>

            <div class="modal-body">
              <div class="userData" v-if="action === 'Edit'">
                <h6>Created By: {{ user_name }}</h6>
                <h6>Created At: {{ createdAt }}</h6>
                <h6>Modified At: {{ updatedAt }}</h6>
              </div>
              <div>
                <div class="label col-md-12">
                  <label class="col-md-1 required-field">Name</label>
                  <input v-model="newFeature.name" type="text" class="form-control m-2" placeholder="Enter a feature name"/>
                </div>
                <div class="label col-md-12">
                  <label class="col-md-1 required-field">Priority</label>
                  <select v-model="newFeature.priority" class="form-control m-2">
                    <option v-for="(priority, index) in priorities" :key="priority" :value="index">{{ priority }}</option>
                  </select>
                </div>
                <div class="label col-md-12">
                  <label class="col-md-1 required-field">Status</label>
                  <select v-model="newFeature.status" class="form-control m-2">
                    <option v-for="status in statuses" :key="status" :value="status">{{ status }}</option>
                  </select>
                </div>
                <div class="label col-md-12">
                  <label class="col-md-1 required-field">Category</label>
                  <select v-model="newFeature.section" class="form-control m-2">
                    <option value="">Select a category</option>
                    <option v-for="section in sections" :key="section" :value="section">{{ section }}</option>
                  </select>
                </div>
                <div class="label col-md-12">
                  <label class="col-md-1 required-field">Size</label>
                  <select v-model="newFeature.size" class="form-control m-2">
                    <option value="">Select a size</option>
                    <option v-for="size in sizes" :key="size" :value="size">{{ size }}</option>
                  </select>
                </div>
                <div class="label col-md-12">
                  <label class="col-md-1 width">Version</label>
                  <input v-model="newFeature.version" type="text" class="form-control m-2" placeholder="Enter a version"/>
                </div>
                <div class="label col-md-12">
                  <label class="col-md-1 required-field">Description</label>
                  <textarea v-model="newFeature.description" rows="8" class="form-control m-2" placeholder="Enter a description"/>
                </div>
                <div class="label col-md-12" v-if="action === 'Edit'">
                  <label class="col-md-1 width">Liked By</label>
                  <ul><li v-for="like in likedBy" :key="like" :value="like">{{like.firstname + ' ' + like.lastname}}</li></ul>
                </div>
              </div>
            </div>

            <div class="modal-footer">
            <button @click="clearForm" class="btn btn-error rounded-0">Cancel</button>
            <button @click="submitFeature" class="btn btn-success rounded-0">Submit</button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-md-2 filters">
      <h2>Filters</h2>
      <div>
        <label for="search">Search</label>
        <input v-model="filterSearch" type="text" class="form-control" @update:modelValue="filterBy()">
        <label for="section" class="filterLabel">Section</label>
        <v-select v-model="filterSection" :options="sections" placeholder="Select option" multiple @update:modelValue="filterBy()">
        </v-select>
        <label for="status" class="filterLabel">Status</label>
        <v-select v-model="filterStatus" :options="statuses" placeholder="Select option" multiple @update:modelValue="filterBy()">
        </v-select>
        <label for="priority" class="filterLabel">Priority</label>
        <v-select v-model="filterPriority" :options="priorities" placeholder="Select option" multiple @update:modelValue="filterBy()">
        </v-select>
        <label for="size" class="filterLabel">Size</label>
        <v-select v-model="filterSize" :options="sizes" placeholder="Select option" multiple @update:modelValue="filterBy()">
        </v-select>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import NavBar from './NavBar';
import authUserId from "../common.js";

export default {
  name: 'FeatureRequestApp',
  props: {
    msg: String
  },
  components: {
    NavBar
  },

  data() {
    return {
      loading: true,
      showModal: false,
      action: "Create",
      showCompleted: false,
      sortBy: "",
      sortOrder: false,
      newFeature: {
        id: "",
        name: "",
        description: "",
        priority: "",
        status: "",
        section: "",
        version: "",
        size: ""
      },
      features: [],
      sections: [
        'Accounting',
        'API',
        'CRM',
        'Extensions',
        'Inventory',
        'Orders',
        'PIM',
        'Publishing',
        'Shipping',
        'Stores',
        'WMS',
        'Other',
      ],
      statuses: [
        'Requested',
        'Approved',
        'In Progress',
        'Complete',
        'Canceled'
      ],
      priorities: [
        'Low',
        'Medium',
        'High',
        'Urgent',
      ],
      createdAt: "",
      updatedAt: "",
      user_name: "",
      filterSection: [],
      filterStatus: ['Requested', 'Approved', 'In Progress'],
      filterPriority: [],
      filterSize: [],
      sizes: [
        'Small',
        'Medium',
        'Large',
        'Extra Large',
      ],
      filterSearch: "",
      likedBy: [],
    }
  },
  created() {
    if (authUserId == null) {
      window.location.reload()
    }
  },
  methods: {
    clearForm() {
        this.showModal = false
        this.action = "Create";
        this.newFeature.id = "";
        this.newFeature.name = "";
        this.newFeature.description = "";
        this.newFeature.section = "";
        this.newFeature.priority = this.priorities[0];
        this.newFeature.status = this.statuses[0];
        this.newFeature.version = "";
        this.newFeature.size = "";
    },

    openForm() {
        this.showModal = true
    },

    async fillForm(id) {
      axios
      .get(this.$apiUrl + 'features/' + id)
      .then(response => {
        this.action = "Edit";
        this.newFeature.id = response.data.id;
        this.newFeature.name = response.data.name;
        this.newFeature.description = response.data.description;
        this.newFeature.section = response.data.section;
        this.newFeature.status = response.data.status;
        this.newFeature.priority = response.data.priority;
        this.newFeature.version = response.data.version;
        this.newFeature.size = response.data.size;
        this.createdAt = response.data.createdAt;
        this.updatedAt = response.data.updatedAt;
        this.user_name = response.data.user_name;
        this.likedBy = response.data.likedBy;
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.openForm()
        this.loading = false
        this.getFeatureRequests()
      })
    },

    async submitFeature() {
      this.loading = true
      let f = this.newFeature;
      if(f.name.length === 0 || f.description.length === 0 || f.section.length === 0 || f.size.length === 0) {
        alert("Please fill out all fields")
        this.loading = false

        return;
      }

      const feature = {
        user_id: authUserId,
        name: f.name,
        description: f.description,
        section: f.section,
        status: f.status,
        priority: f.priority,
        version: f.version,
        size: f.size,
        likes: 0
      }

      if (this.newFeature.id) this.updateFeature(this.newFeature.id, feature)
      else this.createFeature(feature)
    },

    async createFeature(feature) {
      axios
      .post(this.$apiUrl + 'features', feature)
      .then(response => {
        this.features = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.loading = false
        this.clearForm()
        this.getFeatureRequests()
      })
    },

    async updateFeature(id, feature) {
      axios
      .patch(this.$apiUrl + 'features/' + id, feature)
      .then(response => {
        console.log(response.data)
        this.features = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.loading = false
        this.clearForm()
        this.getFeatureRequests()
      })
    },

    async getLikeFeature(id) {
      this.loading = true
      const user_id = authUserId
      axios
        .get(`${this.$apiUrl}features/confirmlike/${id}/${user_id}`)
        .then(response => {
          if (response.data.result == 'exist') {
            alert ("You have already liked this feature !")
            this.loading = false

            return

          } 
            this.likeFeature(id)
        })
    },

    async likeFeature(id) {
      this.loading = true
      const user_id = authUserId
      axios
      .post(`${this.$apiUrl}features/like/${id}/${user_id}`)
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.loading = false
        this.getFeatureRequests()
      })
    },

    async getFeatureRequests() {
      this.loading = true
      axios
      .get(this.$apiUrl + `features?completed=${this.showCompleted}&sortBy=${this.sortBy}&sortOrder=${(this.sortOrder ? "ASC" : "DESC")}&fsection=${this.filterSection}&fstatus=${this.filterStatus}&fpriority=${this.filterPriority}&fsize=${this.filterSize}&fsearch=${this.filterSearch}`)
      .then(response => {
        this.features = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
    },

    sort(by) {
      this.sortBy = by
      this.sortOrder = !this.sortOrder
      this.getFeatureRequests()
    },

    filterBy(){
      this.getFeatureRequests()
    },
  },

  mounted() {
    this.clearForm()
    this.getFeatureRequests()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width:90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  display: block;
  margin-top: 1rem;
}

.userData {
  display: flex;
  justify-content: space-between;
  padding-right: 100px;
}

.filters {
  display: block;
  border-left: 1px solid #ccc;
}

.filterLabel {
  margin-top: 10px;
}

.arrowStyle {
  font-size: 10px;
}

.tableHeader:not(:focus):hover:before{
  content: '\f0dc';
  font-family: "Font Awesome 6 Free";
  font-size: 10px;
  position: relative;
}

.tableHeader:focus {
  content: none;
  outline: none;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.label {
  display: flex;
  align-items: center;
}

.required-field::after {
    content: "*";
    color: red;
}

</style>
